import script from "./CancelConsultationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CancelConsultationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./CancelConsultationDialog.vue?vue&type=style&index=0&id=f30d60fc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f30d60fc"]])

export default __exports__